import { z } from "zod";

export const schema = z.object({
    id: z.number().optional(),
    name: z.string().nullable().optional(),
    system_name: z.string().nullable().optional(),
    css: z.string().nullable().optional(),
    background_color: z.string().nullable().optional(),
    width: z.string().nullable().optional(),
    form_structure_id: z.string().nullable().optional(),
    border_color: z.string().nullable().optional(),
    border: z.string().nullable().optional(),
    primary_color: z.string().nullable().optional(),
    secondary_color: z.string().nullable().optional(),
    show_timer_on_seconds: z.number().nullable().optional(),
    left_path_logo: z.string().nullable().optional(),
    center_logo_path: z.string().nullable().optional(),
    left_logo_id: z.number().nullable().optional(),
    logo_file_id: z.number().nullable().optional(),
    center_logo_id: z.number().nullable().optional(),
    get_money_text: z.string().nullable().optional(),
    header_text: z.string().nullable().optional(),
    meta_title: z.string().nullable().optional(),
    meta_description: z.string().nullable().optional(),
    text_under_submit: z.string().nullable().optional(),
    border_width: z.string().nullable().optional(),

    offers: z.array(z.string()).optional(),
    category: z.string().nullable().optional(),
    label_ids: z.array(z.string()).optional(),
});

export type FormDesignGeneralFormData = z.infer<typeof schema>;
